// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2_545","content":"styles_content__2EjzF","selectAll":"styles_selectAll__2SeVU"};